import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

import { getApiUrl, saveToken } from '@/lib/utils';

const API_URL = getApiUrl();

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed');
          navigate('/login');
          return;
        }

        const response = await axios.post(
          `${API_URL}/api/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Save token to multiple storage locations for PWA persistence
        await saveToken(response.data.session_token);
        toast.success('Welcome to Weakenders!');
        navigate('/dashboard', { state: { user: response.data.user } });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#E63946] mx-auto"></div>
        <p className="mt-6 text-xl text-slate-700 font-semibold">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;